import Api from './Api'

export default {
  // The unit search is resolved by UnifiedSearch/table-backed data in the
  // partner API; the component should not preload or calculate rates locally.
  search(token, params) {
    return Api().post('/search/', params, {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json;version=1.3'
      }
    })
  }
}
